import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";
import Share from "./component/Share";
import { sharecount } from "../redux/actions/commonAction";
import ShareCommon from "./component/ShareCommon";
import { generateResizedImageUrl } from "../utils/httpService";
const CommonHeadCardContent = ({
  url,
  alt,
  mediaimg,
  sandeshske,
  title,
  time,
  post_type,
  id,
  dataClass,
  is_live,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Add local state for the dropdown
  const [showShareDropdown, setShowShareDropdown] = useState(false);

  // Get necessary data from Redux store
  const { 26: sharemsg } = useSelector(
    (state) => state?.SettingReducer?.data
  );

  const handleShareClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowShareDropdown(!showShareDropdown);
  };

  const hasMedia = mediaimg || sandeshske;

  // Construct URL paths for sharing
  const urlshares = "https://" + window.location.hostname + "/" + url;
  const urlshare =
    "https://" + window.location.hostname + "/" + url + "\r\n \r\n";

  const titleText = title + "\r\n";
  const ShareValue = sharemsg?.value + "\r\n \r\n";

  // Function to handle share events and dispatch share count
  const handleShare = (name) => {
    document.getElementById(id).classList.add("d-none");
    dispatch(sharecount(name, id));
    ReactGA.event({ category: "Share", action: name, label: urlshare });
    return false;
  };

  return (
    <div className={`img-in-txt ${dataClass}`}>
      <div className="skeleton-sub" onClick={() => navigate(`/${url}`)}>
        <img
          loading="lazy"
          // src={hasMedia ? mediaimg || sandeshske : sandeshske}
          src={generateResizedImageUrl(558, 328, hasMedia ? mediaimg || sandeshske : sandeshske)}
          alt={alt}
          title={title}
          key={Math.random()}
        />
      </div>
      {post_type === 3 || post_type === 4 ? (
        <p className="button-hover timer_ subvideo-tagline">{time}</p>
      ) : null}
      <div className="content">
        <div className="blog-details pt-2 px-0 pb-0 font-size-gujrat-title common-card-content-title">
          <h3 className="ellipsis mb-2 h6">{title}</h3>
          <div className="cap-post-head-business px-0 mb-0 row d-flex justify-content-between">
            <a>
              <div className="d-flex align-items-center">
                <button className="dropbtn ml-2" aria-label="Share">
                  <i className="fas fa-share"></i> Share
                </button>
                {/* Inline share icons on the same red line */}
                <div
                  className="d-flex align-items-center ml-2"
                  style={{ gap: "8px" }}
                >
                  <ShareCommon
                    id="common-share-dropdown"
                    url={url}
                    media={hasMedia ? mediaimg || sandeshske : null}
                    title={title}
                    dataid={id}
                  />
                </div>
              </div>
            </a>
            {/* <a className="px-2">
              <i className="icone-color-white far fa-clock"></i> Placeholder for
              publish date
            </a> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonHeadCardContent;
